// eslint-disable-next-line import/no-extraneous-dependencies
import { handleActions } from 'redux-actions';

import * as Actions from './actions';

const initialState = {
  isGetListDepartmentRequest: false,
  isGetListDepartmentSuccess: false,
  isGetListDepartmentFailure: false,
  listDepartmentState: {},

  isCreateDepartmentRequest: false,
  isCreateDepartmentSuccess: false,
  isCreateDepartmentFailure: false,

  isUpdateDepartmentRequest: false,
  isUpdateDepartmentSuccess: false,
  isUpdateDepartmentFailure: false,

  isDeleteDepartmentRequest: false,
  isDeleteDepartmentSuccess: false,
  isDeleteDepartmentFailure: false,

  isGetDetailDepartmentRequest: false,
  isGetDetailDepartmentSuccess: false,
  isGetDetailDepartmentFailure: false,
  detailDepartmentState: {},
  errorMessages: [],
};

const reducer = handleActions(
  {
    // #region : Get list departments
    [Actions.getListDepartmentRequest]: (state) => ({
      ...state,
      isGetListDepartmentRequest: true,
      isGetListDepartmentSuccess: false,
      isGetListDepartmentFailure: false,
    }),
    [Actions.getListDepartmentSuccess]: (state, { payload }) => ({
      ...state,
      isGetListDepartmentRequest: false,
      isGetListDepartmentSuccess: true,
      isGetListDepartmentFailure: false,
      listDepartmentState: payload,
    }),
    [Actions.getListDepartmentFailure]: (state, { payload }) => ({
      ...state,
      isGetListDepartmentRequest: false,
      isGetListDepartmentSuccess: false,
      isGetListDepartmentFailure: true,
      errorMessages: payload,
    }),
    // #endregion
    // #region : Create departments
    [Actions.createDepartmentRequest]: (state) => ({
      ...state,
      isCreateDepartmentRequest: true,
      isCreateDepartmentSuccess: false,
      isCreateDepartmentFailure: false,
    }),
    [Actions.createDepartmentSuccess]: (state) => ({
      ...state,
      isCreateDepartmentRequest: false,
      isCreateDepartmentSuccess: true,
      isCreateDepartmentFailure: false,
    }),
    [Actions.createDepartmentFailure]: (state, { payload }) => ({
      ...state,
      isCreateDepartmentRequest: false,
      isCreateDepartmentSuccess: false,
      isCreateDepartmentFailure: true,
      errorMessages: payload,
    }),
    [Actions.resetCreateDepartment]: (state) => ({
      ...state,
      isCreateDepartmentRequest: false,
      isCreateDepartmentSuccess: false,
      isCreateDepartmentFailure: false,
      errorMessages: [],
    }),
    // #endregion

    // #region: update departments
    [Actions.updateDepartmentRequest]: (state) => ({
      ...state,
      isUpdateDepartmentRequest: true,
      isUpdateDepartmentSuccess: false,
      isUpdateDepartmentFailure: false,
    }),
    [Actions.updateDepartmentSuccess]: (state) => ({
      ...state,
      isUpdateDepartmentRequest: false,
      isUpdateDepartmentSuccess: true,
      isUpdateDepartmentFailure: false,
    }),
    [Actions.updateDepartmentFailure]: (state, { payload }) => ({
      ...state,
      isUpdateDepartmentRequest: false,
      isUpdateDepartmentSuccess: false,
      isUpdateDepartmentFailure: true,
      errorMessages: payload,
    }),
    [Actions.resetUpdateDepartment]: (state) => ({
      ...state,
      isUpdateDepartmentRequest: false,
      isUpdateDepartmentSuccess: false,
      isUpdateDepartmentFailure: false,
      errorMessages: [],
    }),

    // #endregion

    // #region : delete departments

    [Actions.deleteDepartmentRequest]: (state) => ({
      ...state,
      isDeleteDepartmentRequest: true,
      isDeleteDepartmentSuccess: false,
      isDeleteDepartmentFailure: false,
    }),
    [Actions.deleteDepartmentSuccess]: (state) => ({
      ...state,
      isDeleteDepartmentRequest: false,
      isDeleteDepartmentSuccess: true,
      isDeleteDepartmentFailure: false,
    }),
    [Actions.deleteDepartmentFailure]: (state, { payload }) => ({
      ...state,
      isDeleteDepartmentRequest: false,
      isDeleteDepartmentSuccess: false,
      isDeleteDepartmentFailure: true,
      errorMessages: payload,
    }),
    [Actions.resetDeleteDepartment]: (state) => ({
      ...state,
      isDeleteDepartmentRequest: false,
      isDeleteDepartmentSuccess: false,
      isDeleteDepartmentFailure: false,
      errorMessages: [],
    }),
    // #endregion

    // #region: Get detail departments
    [Actions.getDetailDepartmentRequest]: (state) => ({
      ...state,
      isGetDetailDepartmentRequest: true,
      isGetDetailDepartmentSuccess: false,
      isGetDetailDepartmentFailure: false,
    }),
    [Actions.getDetailDepartmentSuccess]: (state, { payload }) => ({
      ...state,
      isGetDetailDepartmentRequest: false,
      isGetDetailDepartmentSuccess: true,
      isGetDetailDepartmentFailure: false,
      detailDepartmentState: payload,
    }),
    [Actions.getDetailDepartmentFailure]: (state, { payload }) => ({
      ...state,
      isGetDetailDepartmentRequest: false,
      isGetDetailDepartmentSuccess: false,
      isGetDetailDepartmentFailure: true,
      errorMessages: payload,
    }),
    [Actions.resetDetailDepartment]: (state) => ({
      ...state,
      isGetDetailDepartmentRequest: false,
      isGetDetailDepartmentSuccess: false,
      isGetDetailDepartmentFailure: false,
      errorMessages: [],

    }),

    // #endregion

    [Actions.resetDepartmentsState]: () => initialState,
    // #endregion
  },
  initialState,
);

export default reducer;
